import { Component, Input } from '@angular/core';

import { OktaUserInfo } from '@brightside/core/auth';
import { EmployeeInfoComponent } from '../employee-info/employee-info.component';

@Component({
  selector: 'lib-employee-search-result-wrapper',
  imports: [EmployeeInfoComponent],
  templateUrl: './employee-search-result-wrapper.component.html',
  styleUrl: './employee-search-result-wrapper.component.scss',
})
export class EmployeeSearchResultWrapperComponent {
  @Input() data!: OktaUserInfo;
  @Input() providerId!: string;
}
